/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AdditionalResourceDetailsForFinopsReservationRecommendations extends models.AdditionalResourceDetailsBase {
    constructor() {
        super();
        this.setDiscriminator("AdditionalResourceDetailsForFinopsReservationRecommendations");
    }

    getFixupPrototypeFunction() { return AdditionalResourceDetailsForFinopsReservationRecommendations.fixupPrototype; }

    static newInstance(model: Partial<AdditionalResourceDetailsForFinopsReservationRecommendations>): AdditionalResourceDetailsForFinopsReservationRecommendations {
        let obj = Object.assign(new AdditionalResourceDetailsForFinopsReservationRecommendations(), model);
        AdditionalResourceDetailsForFinopsReservationRecommendations.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AdditionalResourceDetailsForFinopsReservationRecommendations>): AdditionalResourceDetailsForFinopsReservationRecommendations {
        if (!model) return null;
        return AdditionalResourceDetailsForFinopsReservationRecommendations.newInstance(<AdditionalResourceDetailsForFinopsReservationRecommendations> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AdditionalResourceDetailsForFinopsReservationRecommendations) {
        if (!obj) return;

        models.AdditionalResourceDetailsForFinopsReservationRecommendations.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AdditionalResourceDetailsForFinopsReservationRecommendations): boolean {
        if (models.AdditionalResourceDetailsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AdditionalResourceDetailsForFinopsReservationRecommendations.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.term === undefined) {
            this.term = 0;
        }
        if (this.lookback_period === undefined) {
            this.lookback_period = 0;
        }
    }

    /**
     * Resource Id
     */
    resource_id: string;

    /**
     * Term for reservation recommendation
     */
    term: number;

    /**
     * sys id for the cloud native recommendation
     */
    recommendation_id: string;

    /**
     * region name
     */
    location: string;

    /**
     * lookback period in days
     */
    lookback_period: number;

}
